import * as React from 'react';
import * as Redux from 'redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';

const wrapperStyle: CSSProperties = {
    position: 'fixed',
    width: '350px',
    height: '450px',
    marginTop: '-225px',
    top: '50%',
    marginLeft: '-175px',
    left: '50%',
    zIndex: 99,
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 0 5px 0',
}

const hdrStyle: CSSProperties = {
    fontSize:'10px',
    letterSpacing: '2px',
}

const innerListStyle: CSSProperties = {
    margin: '2px 20px 20px 20px',
    border: Tgcc.Styles.singleBorder,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
}

const buttonStyle: CSSProperties = {
    backgroundColor: 'rgb(58, 84, 180)',
    fontSize: '10px',
    letterSpacing: '3px',
    width: '50%',
    alignSelf: 'center',
    textAlign: 'center',
    padding: '3px',
    color:'white',
    fontFamily:'Lulo'
}

const itemStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'row',
    cursor: 'pointer',
    width: '275px',
    padding: '5px'
}

const imgStyle: CSSProperties = {
    height: "50px",
    alignSelf: "center",
    margin: '5px'
}

const itemTextStyle: CSSProperties = {
    fontSize: '10px',
    letterSpacing: '3px',
    padding: '10px',
    margin: '10px',
    textAlign: 'center',
    background: Tgcc.Styles.inputBackground,
    width: '220px',
    alignSelf: 'center',
    fontFamily:'Lulo',
    '@media (max-width:320px)': {
        width:'150px'
    }
}
const dimensions: CSSProperties = {
    textAlign:'center',
    fontFamily:'BarlowLight',
    color:'rgb(97, 96, 96)',
    marginTop:'-10px',
    fontSize:'12px',
    marginLeft:'54px'
}

class Props extends Tgcc.BaseProps{
    visible: boolean;
    fontFamily?:string;
    btnColor?:string;
}

class _CampusBackLocator extends React.Component<Props, any>{

    componentWillMount(){
        if(this.props.fontFamily){
            itemStyle.fontFamily = this.props.fontFamily
            dimensions.fontFamily = this.props.fontFamily
            itemTextStyle.fontFamily = this.props.fontFamily
            buttonStyle.fontFamily = this.props.fontFamily
        }
        if(this.props.btnColor){
            buttonStyle.backgroundColor = this.props.btnColor
        }
    }
    getLocationOption(loc: string){
        var txt: string;
        var img: string;
        var dim: string;
        switch(loc){
            case Tgcc.BackLocations.None: 
                txt = "None";
                img = null;
                break;
            case Tgcc.BackLocations.SmallBack:
                txt = "small back"
                img = Tgcc.ResolveUrl('~/images/Small.Front.png')
                dim = "Print Size: 4.0 x 4.0"
                break;
            case Tgcc.BackLocations.MediumBack:
                txt = "medium back"
                img = Tgcc.ResolveUrl('~/images/Medium.Front.png')
                dim = "Print Size: 9.0 x 9.0"
                break;
            case Tgcc.BackLocations.FullBack:
                txt = "full back"
                img = Tgcc.ResolveUrl('~/images/Full.Front.png')
                dim = "Print Size: 12.0 x 14.0"
                break;
        }
        return (
            <div>
                <div onClick={() => this.selectLocation(loc)} style={itemStyle}>
                    <img style={imgStyle} src={img}/>
                    <div className="hoverBorder" style={itemTextStyle}>{txt}</div>
                </div>
                <div style={dimensions}>{dim}</div>
            </div>
        );

    }

    backToProof = () => {
        this.props.dispatch( { type: Tgcc.StateAction.SetEditState, payload: null})
    }

    selectLocation = (loc: string) => {
        this.props.dispatch({type: Tgcc.StateAction.SetBackLocation, payload: loc});
    }

    render() {
        if(!this.props.visible){
            document.body.style.overflow = 'auto'; // re-enable scrolling on body
            return ( <a/> )
        }

        document.body.style.overflow = 'hidden'; // disable scrolling on body
        return (
            <div style={wrapperStyle}>
                <div style={hdrStyle}>choose back location</div>
                <div style={innerListStyle}>
                    {this.getLocationOption(Tgcc.BackLocations.None)}
                    {this.getLocationOption(Tgcc.BackLocations.SmallBack)}
                    {this.getLocationOption(Tgcc.BackLocations.MediumBack)}
                    {this.getLocationOption(Tgcc.BackLocations.FullBack)}
                </div>
                <div className="hoverBorder" style={buttonStyle} onClick={this.backToProof}>back</div>
            </div>
        )
    }


}


const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { visible: state.EditState == Tgcc.EditStates.SelectBackLocation }
};
export var CampusBackLocator = connect(mapStateToProps)(Radium(_CampusBackLocator));